import NextLazyImage from "@/components/Core/NextLazyImage";
import SimpleMarquee from "@/components/Shared/AnimatedMarquee";
import mq from "@/utils/mq";
import { useEffect } from "react";
import { useState } from "react";
import styled, { css } from "styled-components";

const MarqueeContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 32px;
  padding: 84px 0;
  > * {
    will-change: transform !important;
  }
  ${mq.mobile(css`
    grid-gap: 8px;
  `)};
`;

const MarqueeImageObject = styled.div`
  height: 320px;
  position: relative;
  width: auto;
  margin: 0 16px;
  user-select: none;
  pointer-events: none;
  will-change: transform;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  ${mq.mobile(css`
    height: 260px;
    margin: 0 4px;
    width: unset;
    img {
      width: unset;
    }
  `)};
`;

export default function ImageMarquee({ rowOne, rowTwo }) {
  const [isMobile, setIsMobile] = useState<boolean | null>(null);
  const MOBILE_BREAKPOINT = 768;
  const DESKTOP_HEIGHT = 32;
  const MOBILE_HEIGHT = 24;

  useEffect(() => {
    const checkMobile = () => {
      const newIsMobile = window.innerWidth < MOBILE_BREAKPOINT;
      if (isMobile === null || newIsMobile !== isMobile) {
        setIsMobile(newIsMobile);
      }
    };

    checkMobile();

    const resizeObserver = new ResizeObserver(() => {
      checkMobile();
    });

    resizeObserver.observe(document.body);

    return () => resizeObserver.disconnect();
  }, [isMobile]);

  const marqueeProps = {
    baseVelocity: isMobile ? 1.2 : 1.8,
    useScrollVelocity: true,
    slowDownFactor: 0.4,
    slowdownOnHover: true,
    draggable: true,
    dragSensitivity: isMobile ? 0.07 : 0.07,
    dragVelocityDecay: 0.96,
    grabCursor: true,
    scrollAwareDirection: true,
  };

  return (
    <MarqueeContainer>
      <SimpleMarquee {...marqueeProps}>
        {rowOne?.map((image) => (
          <MarqueeImageObject key={image.id}>
            <img src={image.filename} alt={image.alt} />
          </MarqueeImageObject>
        ))}
      </SimpleMarquee>
      <SimpleMarquee direction='left' {...marqueeProps}>
        {rowTwo?.map((image) => (
          <MarqueeImageObject key={image.id}>
            <img src={image.filename} alt={image.alt} />
          </MarqueeImageObject>
        ))}
      </SimpleMarquee>
    </MarqueeContainer>
  );
}
